<template>
    <!--使用者資料-->
    <el-dialog :title="dialogTitle" width="40%" v-model="dialogFormVisible" top="7vh"
               @opened="onDialogOpen" center label-width="" :lock-scroll="false" :close-on-click-modal="false">
        <el-form :model="form" :rules="rules" ref="formRef" :inline-message="true" label-position="top">
            <el-row>
                <el-col :span="12" style="padding: 0 6px;">
                    <el-form-item label="登入帳號" prop="USER_CODE">
                        <el-input v-model="form.USER_CODE" :disabled="IDdisabled"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" style="padding: 0 6px;">
                    <el-form-item label="姓名" prop="USER_NAME">
                        <el-input v-model="form.USER_NAME"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12" style="padding: 0 6px;">
                    <el-form-item label="連絡電話" prop="TEL_NO">
                        <el-input v-model="form.TEL_NO"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col style="padding: 0 6px;">
                    <el-form-item label="E-MAIL" prop="EMAIL">
                        <el-input v-model="form.EMAIL"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" style="padding: 0 6px;">
                    <el-form-item label="密碼到期日" prop="PWD_EXPIRY_DATE">
                        <el-date-picker v-model="form.PWD_EXPIRY_DATE" format="YYYY-MM-DD" value-format="YYYY/MM/DD" type="date" placeholder="Pick a day" style="width:100%;" />
                    </el-form-item>
                </el-col>
                <el-col :span="12" style="padding: 0 6px;">
                    <el-form-item label="Set Password" prop="PASSWORD">
                        <el-input v-model="form.PASSWORD" type="password" show-password></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" style="padding: 0 6px;">
                    <el-form-item label="職務" prop="ROLE_SEQ">
                        <el-select v-model="form.ROLE_SEQ" style="width:100%;">
                            <el-option v-for="item in roleOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" style="padding: 0 6px;">
                    <el-form-item label="Confirm Password" prop="PASSWORD_AGAIN">
                        <el-input v-model="form.PASSWORD_AGAIN" type="password" show-password></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col style="padding: 0 6px;">
                    <el-form-item label="Remarks" prop="REMARKS">
                        <el-input v-model="form.REMARKS" type="textarea" :rows="3"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="5" v-show="addOrEdit=='edit'">
                <el-col :span="3" style="text-align:center">
                    Creator
                </el-col>
                <el-col :span="9">
                    {{form.CREATE_USER_NAME}}<br />
                    {{form.CREATE_TIME}}
                </el-col>
                <el-col :span="3" style="text-align:center">
                    Editor
                </el-col>
                <el-col :span="9">
                    {{form.EDIT_USER_NAME}}<br />
                    {{form.EDIT_TIME}}
                </el-col>
            </el-row>
        </el-form>
        <template #footer class="dialog-footer">
            <el-button type="info" @click="dialogFormVisible = false" style="width: 150px;">Cancel</el-button>
            <el-button type="primary" @click="onSubmit('form')" style="width: 150px;">Save</el-button>
        </template>
    </el-dialog>
</template>

<script lang="js">
    import { defineComponent } from 'vue';
    import { ElMessage, ElMessageBox } from 'element-plus'
    import $api from '@/utils/axios';
    import { useStore } from "vuex";
    const store = useStore();

    export default defineComponent({
        props: ["VENDOR_ID"],
        data() {
            return {
                dialogTitle: '',       //dialog標題
                dialogFormVisible: false, //顯示dialog
                IDdisabled: false,     //編輯時ID狀態
                addOrEdit: '',
                formData: null,
                roleOptions: [],        //[職務]下拉選項
                form: {
                    VENDOR_ID: '',
                    USER_CODE: '',
                    USER_NAME: '',
                    EMAIL: '',
                    TEL_NO: '',
                    ROLE_SEQ: '',
                    ACCT_ENABLE: 'Y',
                    PWD_EXPIRY_DATE: '',
                    PASSWORD: '',
                    PASSWORD_AGAIN: '',
                },
                rules: {
                    USER_CODE: [{ required: true, message: '請輸入員工代碼', trigger: 'blur' }],
                    USER_NAME: [{ required: true, message: '請輸入員工姓名', trigger: 'blur' }],
                    ROLE_SEQ: [{ required: true, message: '請輸入角色', trigger: 'blur' }],
                    PASSWORD: [{
                        validator: (rule, value, callback) => {
                            if (this.addOrEdit == 'add') {
                                if (value == '') callback(new Error('請輸入密碼'));
                                callback();
                            } else {
                                if (value == '' && this.form.PASSWORD_AGAIN != '') {
                                    callback(new Error('請輸入密碼'));
                                }
                            }
                            callback();
                        }, trigger: 'blur'
                    }],
                    PASSWORD_AGAIN: [{
                        validator: (rule, value, callback) => {
                            if (this.addOrEdit == 'add') {
                                if (value == '') callback(new Error('請再次輸入密碼'));
                                callback();
                            } else {
                                if (this.form.PASSWORD != '' && value == '') {
                                    callback(new Error('請再次輸入密碼'));
                                } else if (value !== this.form.PASSWORD) {
                                    if (this.form.PASSWORD == '') this.formRef.validateField('PASSWORD');
                                    callback(new Error('兩次輸入密碼不一致!'));
                                } else {
                                    callback();
                                }
                            }
                        }, trigger: 'blur'
                    }]
                }
            };
        },
        methods: {
            onDialogOpen() {
                this.$nextTick(() => {
                    if (this.addOrEdit == 'add') {
                        this.$refs['formRef'].resetFields();
                        this.form.VENDOR_ID = this.formData;
                    } else {
                        this.form = this.formData;
                    }
                    this.getOptions(this.form.VENDOR_ID);
                });
            },
            getOptions(VENDOR_ID) {
                $api.GET('/api/BaseRole/GetRoleOptions',
                    { COMP_ID: VENDOR_ID }
                ).then((response) => {
                    this.roleOptions = response;
                });
            },
            onAddClick(VENDOR_ID) {
                this.dialogTitle = "[新增]";
                this.addOrEdit = 'add';
                this.IDdisabled = false;
                this.dialogFormVisible = true;
                this.formData = VENDOR_ID;
            },
            onEditClick(VENDOR_ID, data) {
                this.dialogTitle = "[編輯]";
                this.addOrEdit = 'edit';
                this.IDdisabled = true;
                this.dialogFormVisible = true;
                this.formData = data;
            },
            onSubmit() {
                this.$refs['formRef'].validate((valid) => {
                    if (valid) {
                        if (this.addOrEdit == 'add') {
                            $api.POST('/api/OutletUser/Add', this.form
                            ).then((res) => {
                                if (res == 1) {
                                    ElMessageBox.alert('新增成功!', '提示', {
                                        confirmButtonText: '確定',
                                        callback: action => {
                                            this.dialogFormVisible = false;
                                            this.$emit('finish');
                                        }
                                    });
                                } else if (res == -2) {
                                    ElMessageBox.alert('該公司已存在該使用者名稱，無法新增!', '提示', {
                                        confirmButtonText: '確定'
                                    });
                                } else {
                                    ElMessageBox.alert('新增失敗!', '提示', {
                                        confirmButtonText: '確定'
                                    });
                                }
                            })
                        } else {
                            $api.POST('/api/OutletUser/Edit', this.form
                            ).then((res) => {
                                if (res == 1) {
                                    ElMessageBox.alert('編輯成功!', '提示', {
                                        confirmButtonText: '確定',
                                        callback: action => {
                                            this.dialogFormVisible = false;
                                            this.$emit('finish');
                                        }
                                    });
                                } else {
                                    ElMessageBox.alert('編輯失敗!', '提示', {
                                        confirmButtonText: '確定'
                                    });
                                }
                            })
                        }
                    }
                });
            }
        },
        mounted() {
        }
    });
</script>